import { MODAL_ACTIONS } from 'food-benefit.module/common/domain/constants';

class ModalSendAllCardsController {
  constructor(EventEmitter) {
    'ngInject';
    this.EventEmitter = EventEmitter;
    this.cancel = MODAL_ACTIONS.CANCEL;
    this.send = MODAL_ACTIONS.SEND;
  }

  $onInit() {
    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
    }
  }

  actionButton(action) {
    this.setAction(this.EventEmitter({
      status: action,
    }));
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.SEND'
      },
      {
        literal: 'GLOBALS.BUTTON_ACTION.CANCEL'
      }
    ];
  }

}

export default ModalSendAllCardsController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestModal/modalSendAllCards/modalSendAllCards.controller.js